import React, { useState, useEffect } from 'react';
import { Loader } from '../utils/loader/Loader';
import './slider.css';
import '../../images/banner/header00.jpg';

type props = {}

export const Slider = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>
        
        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        return <Loader />;
    }
    else 
        return <div className="slider_area">
            <div className="slider_active owl-carousel">
                <div className="single_slider  d-flex align-items-center slider_bg_2 overlay2">
                    {/* <div id='stars'></div>
                    <div id='stars2'></div>
                    <div id='stars3'></div> */}
                    {/* <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="slider_text ">
                                    <h3> 
                                        A powerful combination of solutions <br></br>
                                        all connected
                                    </h3>
                                    <p>we ‘re just around the corner and eager to get to know you. <br></br>
                                        Financial market solutions for your specific needs.
                                    </p>
                                    <div className="video_service_btn">
                                        <a href="/#" className="boxed-btn3">Our Services</a>
                                        <a href="/#" className="boxed-btn3-white"> <i className="fa fa-play"></i>See How it Work</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* <div className="single_slider  d-flex align-items-center slider_bg_1 overlay2">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="slider_text ">
                                    <h3> 
                                        Grow Big with <br></br>
                                        Musicol Business 
                                    </h3>
                                    <p>
                                        Nam libero tempore, cum soluta nobis est eligendi optio <br></br>
                                        cumque nihil impedit quo minus.
                                    </p>
                                    <div className="video_service_btn">
                                        <a href="/#" className="boxed-btn3">Our Services</a>
                                        <a href="/#" className="boxed-btn3-white"> <i className="fa fa-play"></i>See How it Work</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single_slider  d-flex align-items-center slider_bg_2 overlay2">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="slider_text ">
                                    <h3> 
                                        Grow Big with <br></br>
                                        Musicol Business 
                                    </h3>
                                    <p>
                                        Nam libero tempore, cum soluta nobis est eligendi optio <br></br>
                                        cumque nihil impedit quo minus.
                                    </p>
                                    <div className="video_service_btn">
                                        <a href="/#" className="boxed-btn3">Our Services</a>
                                        <a href="/#" className="boxed-btn3-white"> <i className="fa fa-play"></i>See How it Work</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
}
                           